import { useEffect } from 'react';

import { useCashWithdrawal } from '../../hooks/cash/useCashWithdrawal';
import { useCashSession } from '../../hooks/cash/useCashSession';

import CashSessionHeader from '../CashStatus/CashSessionHeader';
import CashSessionStats from '../CashStatus/CashSessionStats';
import CashSessionFooter from '../CashStatus/CashSessionFooter';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';

const CashWithdrawalSessionCard = () => {
  const { open } = useCashWithdrawal();
  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  if (!activeSession) {
    return <EmptyCashSessionState />;
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <CashSessionHeader
        onAction={open}
        actionLabel="Nuevo Retiro"
        actionColor="#DC3545"
      />

      <CashSessionStats
        registerName={activeSession.registerName}
        userName={activeSession.openedByName}
        openingTime={activeSession.openedAt}
      />

      <CashSessionFooter currentBalance={activeSession.currentBalance} />
    </div>
  );
};

export default CashWithdrawalSessionCard;
